import React from "react";

export default function CheckboxCell({
  checked,
  indeterminate = false,
  onChange,
  ariaLabel,
}) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (ref.current) ref.current.indeterminate = !checked && indeterminate;
  }, [checked, indeterminate]);
  return (
    <input
      ref={ref}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      onClick={(e) => e.stopPropagation()}
      aria-label={ariaLabel || "Select"}
      className="w-4 h-4 rounded border-slate-300 accent-[#1E3A8A] cursor-pointer"
    />
  );
}
